import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Pricelist from "@/pages/Pricelist";
import Admin from "@/pages/Admin";
import Quotes from "@/pages/Quotes";
import QuoteBuilder from "@/pages/QuoteBuilder";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/pricelist" replace />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/pricelist"
            element={<ProtectedRoute><Pricelist /></ProtectedRoute>}
          />
          <Route
            path="/quotes"
            element={<ProtectedRoute><Quotes /></ProtectedRoute>}
          />
          <Route
            path="/quotes/new"
            element={<ProtectedRoute><QuoteBuilder /></ProtectedRoute>}
          />
          <Route
            path="/admin"
            element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>}
          />
          <Route path="*" element={<Navigate to="/pricelist" replace />} />
        </Routes>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
